import { createClient } from '@supabase/supabase-js'

// Regular client with anonymous key for normal operations
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://xbpmzamgxvdykielwhlo.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhicG16YW1neHZkeWtpZWx3aGxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg1ODkzODksImV4cCI6MjA2NDE2NTM4OX0.STbQe8rxZDgQYvtOdc_wjQsR5BVNzD-9FKQ5uDrUwPc'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// API url for admin functions
const apiUrl = 'https://wsp-vacation-request-backend.onrender.com/api/user-management';

// Admin operations via API
export const callAdminFunction = async (action, data) => {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Not authenticated')
  
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify({ action, ...data })
  })
  
  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.error || 'Unknown error')
  }
  
  return response.json()
}